import React from "react";
import { ParagraphNext } from "@/model";

import { ParagraphInputsProps } from "../model";
import { NextConditionSortableList } from "../input";


const ParagraphNextCardInputs: React.FC<ParagraphInputsProps<ParagraphNext>> = (props) => {
    const { paragraph, onChange } = props;

    return (<>
        <NextConditionSortableList className="col-span-2 flex flex-col gap-1.5"
                                   defaultConditions={paragraph.data ?? []}
                                   onChangeConditions={conditions => onChange({
                                       ...paragraph,
                                       data: conditions
                                   })}
        />
    </>);
};

export default ParagraphNextCardInputs;
